import React, { useState, useEffect } from 'react';

function TenantFeatures({ customer }) {
  const [featureFlags, setFeatureFlags] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (!customer || !customer.CustomerID) {
      setFeatureFlags(null);
      return;
    }

    setLoading(true);
    setError(null);

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/customers/${customer.CustomerID}/features`)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to load feature flags');
        }
        return res.json();
      })
      .then((data) => {
        setFeatureFlags(data);
      })
      .catch((err) => {
        console.error('Error fetching feature flags:', err);
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [customer]);

  const handleToggleFeature = async (featureFlagId, currentValue) => {
    if (!featureFlags) return;

    setUpdating(true);
    setError(null);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/customers/${customer.CustomerID}/features/${featureFlagId}`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ IsEnabled: !currentValue }),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to update feature flag');
      }

      setFeatureFlags((prevFlags) =>
        prevFlags.map((flag) =>
          flag.FeatureFlagID === featureFlagId
            ? { ...flag, IsEnabled: !flag.IsEnabled }
            : flag
        )
      );
    } catch (err) {
      console.error('Error updating feature flag:', err);
      setError(err.message);
    } finally {
      setUpdating(false);
    }
  };

  if (!customer || !customer.CustomerID) {
    return null;
  }

  return (
    <div style={{ border: '1px solid #ccc', padding: '16px', borderRadius: '8px' }}>
      <h3>Preview Features</h3>
      
      {loading && <p>Loading feature flags...</p>}
      
      {error && (
        <div style={{ color: 'red', marginBottom: '12px' }}>
          Error: {error}
        </div>
      )}

      {featureFlags && !loading && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {featureFlags.map((flag) => (
            <div key={flag.FeatureFlagID} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
                <input
                  type="checkbox"
                  checked={flag.IsEnabled}
                  onChange={() => handleToggleFeature(flag.FeatureFlagID, flag.IsEnabled)}
                  disabled={updating}
                  style={{ cursor: updating ? 'not-allowed' : 'pointer' }}
                />
                <span>{flag.FeatureName}</span>
              </label>
              {updating && <span style={{ fontSize: '12px', color: '#666' }}>Updating...</span>}
            </div>
          ))}
          
          <div style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
            <p>Customer: {customer.CompanyName}</p>
            <p>Total Features: {featureFlags.length}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default TenantFeatures;

